// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseIcon_root__3UmqG","variant1":"CloseIcon_variant1__i6M-V","variant2":"CloseIcon_variant2__Qn8QN"};